"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartSummaryPurchaseToolbar = void 0;
const React = require("react");
const react_1 = require("react");
const Button_1 = require("../../../../../../components/base/atoms/Button");
const SalesOrderContext_1 = require("../../../contexts/SalesOrderContext");
const RetailLocationsContext_1 = require("../../../contexts/RetailLocationsContext");
const useRequiredContext_1 = require("../../../../../../hooks/useRequiredContext");
const RetailEventTrackingContext_1 = require("../../../contexts/RetailEventTrackingContext");
const useRetailLocationAvailability_1 = require("../../../hooks/useRetailLocationAvailability");
const Currency_1 = require("../../../../../../components/base/atoms/Currency");
const CheckoutModal_1 = require("../../../modals/CheckoutModal");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "CartSummaryPurchaseToolbar");
const CartSummaryPurchaseToolbar = ({}) => {
    const { retailLocation } = (0, react_1.useContext)(RetailLocationsContext_1.RetailLocationsContext);
    const { salesOrderItems, totalPrice, cartNoLongerExists, setHasSalesOrderError, temporaryAddress } = (0, react_1.useContext)(SalesOrderContext_1.SalesOrderContext);
    const { logBeginCheckout } = (0, useRequiredContext_1.useRequiredContext)(RetailEventTrackingContext_1.RetailEventTrackingContext);
    const [checkoutModal, showCheckoutModal] = (0, react_1.useState)(false);
    const canPlaceOrder = (0, useRetailLocationAvailability_1.useCanPlaceOrder)(retailLocation, temporaryAddress);
    const isMounted = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        isMounted.current = true;
        if (!cartNoLongerExists) {
            return;
        }
        if (isMounted) {
            showCheckoutModal(false);
        }
        return () => {
            // when the component unmounts, set isMounted to false
            isMounted.current = false;
        };
    }, [cartNoLongerExists]);
    const startCheckout = (0, react_1.useMemo)(() => {
        if (!canPlaceOrder) {
            return null;
        }
        return () => {
            showCheckoutModal(true);
            logBeginCheckout(salesOrderItems, totalPrice);
        };
    }, [canPlaceOrder]);
    const purchaseNowBtnText = (0, react_1.useMemo)(() => (canPlaceOrder ? "Purchase now" : "Unavailable"), [canPlaceOrder]);
    return (React.createElement("div", { className: css("") },
        React.createElement("div", { className: css("totalPrice") },
            React.createElement("span", null, "Total: "),
            React.createElement(Currency_1.Currency, null, totalPrice)),
        React.createElement(Button_1.Button, { className: css("purchaseNowBtn"), onClick: startCheckout }, purchaseNowBtnText),
        React.createElement(CheckoutModal_1.CheckoutModal, { show: checkoutModal, dismiss: () => {
                setHasSalesOrderError(false);
                showCheckoutModal(false);
            } })));
};
exports.CartSummaryPurchaseToolbar = CartSummaryPurchaseToolbar;
//# sourceMappingURL=index.js.map